export default "__VITE_ASSET__D25Q9S8I__"